// jQuery free
const CLASS_EFFECT_SHAKE = '--effectShake';


export function effectShakeElement(htmlElement) {
    htmlElement.classList.add(CLASS_EFFECT_SHAKE);
    htmlElement.addEventListener('animationend', () => {
        htmlElement.classList.remove(CLASS_EFFECT_SHAKE);
    }, {once: true});
}